import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PainterGeorge() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');

  const painter = {
    id: "painters-george",
    name: "Painters George",
    location: "George, Garden Route",
    rating: 4.7,
    reviews: 156,
    specialties: ["Garden Route Properties", "Coastal Painting", "Heritage Homes", "Commercial Projects"],
    image: "https://public.readdy.ai/ai/img_res/5c12dc0bb6473bf48487855af97c99c5.jpg",
    verified: true,
    yearsExperience: 14,
    website: "https://paintersgeorge.co.za",
    email: "info@paintersgeorge.co.za",
    description: "Professional painting contractors serving George and the greater Garden Route area. We specialize in residential and commercial painting projects, with expertise in heritage property restoration and modern coastal homes.",
    services: [
      "Interior House Painting",
      "Exterior House Painting", 
      "Commercial Painting",
      "Heritage Property Restoration",
      "Roof Painting & Coatings",
      "Waterproofing Services",
      "Industrial Painting",
      "Color Consultation"
    ],
    serviceAreas: ["George", "Knysna", "Plettenberg Bay", "Mossel Bay", "Oudtshoorn", "Garden Route", "Klein Karoo", "Southern Cape"],
    gallery: [
      "https://readdy.ai/api/search-image?query=Beautiful%20interior%20living%20room%20painted%20by%20professional%20painters%20in%20George%20Garden%20Route%2C%20modern%20home%20with%20fresh%20walls%2C%20quality%20paint%20finish%2C%20mountain%20view%2C%20bright%20natural%20lighting%2C%20clean%20professional%20painting%20work&width=400&height=300&seq=george-gallery-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Exterior%20house%20painting%20project%20in%20George%20Garden%20Route%2C%20residential%20home%20with%20fresh%20paint%2C%20professional%20painters%20working%2C%20quality%20exterior%20finish%2C%20mountain%20setting%2C%20well-maintained%20property&width=400&height=300&seq=george-gallery-2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Commercial%20painting%20project%20in%20George%2C%20professional%20painters%20working%20on%20business%20building%2C%20quality%20commercial%20paint%20finish%2C%20modern%20architecture%2C%20organized%20work%20site&width=400&height=300&seq=george-gallery-3&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Heritage%20home%20restoration%20painting%20in%20George%2C%20professional%20painters%20working%20on%20historic%20property%2C%20quality%20restoration%20work%2C%20traditional%20architecture%2C%20expert%20craftsmanship&width=400&height=300&seq=george-gallery-4&orientation=landscape"
    ],
    testimonials: [
      {
        name: "Michael Stevens",
        rating: 5,
        comment: "Outstanding work on our Garden Route holiday home. The team understood the unique climate challenges and delivered exceptional results that have lasted beautifully."
      },
      {
        name: "Susan de Villiers", 
        rating: 5,
        comment: "Professional service from start to finish. They completed our George home painting ahead of schedule and the quality exceeded all expectations."
      },
      {
        name: "James Robertson",
        rating: 4,
        comment: "Excellent painters for heritage properties. Their attention to detail and knowledge of traditional techniques is impressive."
      }
    ]
  };

  useEffect(() => {
    document.title = "Painters George | Professional House Painting Services Garden Route | Residential & Commercial";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Painters George provides professional painting services in George, Garden Route. Specializing in residential and commercial painting, interior and exterior work. Quality painting contractors in the Garden Route.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Painters George, house painters George, painting contractors Garden Route, residential painting, commercial painting services');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-96 bg-gradient-to-r from-blue-600 to-blue-800">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20beautiful%20Garden%20Route%20home%20in%20George%20South%20Africa%2C%20stunning%20mountain%20views%20with%20Outeniqua%20Mountains%20backdrop%2C%20painters%20in%20clean%20uniforms%20with%20quality%20equipment%2C%20well-maintained%20property%20with%20modern%20architecture%2C%20bright%20natural%20lighting%2C%20high%20quality%20residential%20painting%20project%20in%20scenic%20setting&width=1200&height=600&seq=george-painters-hero&orientation=landscape)` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center">
          <div className="text-white">
            <div className="flex items-center mb-4">
              <h1 className="text-4xl md:text-5xl font-bold mr-4">{painter.name}</h1>
              {painter.verified && (
                <div className="bg-green-500 text-white px-3 py-1 rounded-full text-sm font-semibold flex items-center">
                  <i className="ri-shield-check-line mr-1"></i>
                  Verified
                </div>
              )}
            </div>
            
            <p className="text-xl mb-4 flex items-center">
              <i className="ri-map-pin-line mr-2"></i>
              {painter.location}
            </p>
            
            <div className="flex items-center space-x-6 mb-6">
              <div className="flex items-center">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className={`ri-star-fill ${i < Math.floor(painter.rating) ? 'text-yellow-400' : 'text-gray-400'}`}></i>
                ))}
                <span className="ml-2">{painter.rating} ({painter.reviews} reviews)</span>
              </div>
              <span>{painter.yearsExperience} years experience</span>
            </div>
            
            <div className="flex space-x-4">
              <button 
                onClick={() => navigate('/quote')}
                className="bg-lime-400 text-black px-6 py-3 rounded-lg font-semibold hover:bg-lime-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                Get Free Quote
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Navigation Tabs */}
      <section className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex space-x-8">
            {[
              { id: 'overview', label: 'Overview' },
              { id: 'services', label: 'Services' },
              { id: 'gallery', label: 'Gallery' },
              { id: 'reviews', label: 'Reviews' },
              { id: 'contact', label: 'Contact' }
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`py-4 px-2 border-b-2 font-medium text-sm whitespace-nowrap cursor-pointer ${
                  activeTab === tab.id
                    ? 'border-lime-500 text-lime-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>
      </section>

      {/* Content Sections */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {activeTab === 'overview' && (
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="lg:col-span-2">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">About Painters George - Your Trusted Garden Route Painting Specialists</h2>
                <p className="text-gray-700 text-lg leading-relaxed mb-8">
                  {painter.description} With over 14 years of experience serving the Garden Route community, we have established ourselves as the premier painting contractors in the region, known for our exceptional craftsmanship, reliability, and commitment to customer satisfaction.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Professional Painting Services in George</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Located in the heart of the Garden Route, George presents unique painting challenges due to its diverse climate conditions, ranging from coastal humidity to mountain weather patterns. Our team has developed specialized techniques and material selections that ensure optimal performance across all these varied environmental conditions. We understand that properties in George, from holiday homes to permanent residences, require painting solutions that can withstand the region's distinctive weather patterns while maintaining their aesthetic appeal year-round.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Why Choose Our George Painting Services</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Our reputation in George and throughout the Garden Route has been built on consistent delivery of superior painting services that exceed client expectations. We combine traditional craftsmanship with modern techniques and premium materials to ensure every project meets the highest standards. Our team consists of skilled professionals who understand the local architecture, from Victorian heritage homes to contemporary coastal designs, ensuring that each painting project enhances the property's character while providing long-lasting protection.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Garden Route Climate Expertise</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  The Garden Route's unique position between mountains and ocean creates specific challenges for exterior painting projects. Our extensive experience in this region has taught us how to select and apply paints that resist moisture damage, UV degradation, and temperature fluctuations. We use specialized primers and topcoats that are specifically formulated for South African coastal and mountain climates, ensuring that your investment in professional painting services provides maximum value and longevity.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Heritage Property Restoration Specialists</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  George is home to numerous heritage properties that require specialized restoration techniques and materials. Our team has extensive experience working with historical buildings, understanding the importance of preserving architectural integrity while updating properties for modern living. We work closely with heritage consultants and use period-appropriate materials and techniques when required, ensuring that restoration projects meet both aesthetic and conservation standards.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Quality Materials and Techniques</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  We exclusively use premium paint brands that are proven to perform well in South African conditions. Our material selection process considers factors such as UV resistance, moisture protection, breathability, and color retention. We maintain relationships with leading paint manufacturers to ensure access to the latest innovations in paint technology, including eco-friendly options that provide excellent performance while minimizing environmental impact.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Comprehensive Project Management</h3>
                <p className="text-gray-700 leading-relaxed mb-8">
                  Every painting project in George is managed with meticulous attention to detail, from initial consultation through final inspection. We provide detailed project timelines, regular progress updates, and maintain clean, organized work sites that minimize disruption to your daily routine. Our project management approach ensures that deadlines are met, budgets are respected, and quality standards are maintained throughout the entire process.
                </p>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">Our Specialties</h3>
                    <div className="flex flex-wrap gap-2">
                      {painter.specialties.map((specialty, index) => (
                        <span key={index} className="bg-lime-100 text-lime-800 px-3 py-1 rounded-full text-sm font-medium">
                          {specialty}
                        </span>
                      ))}
                    </div>
                  </div>
                  
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">Service Areas</h3>
                    <div className="space-y-2">
                      {painter.serviceAreas.slice(0, 4).map((area, index) => (
                        <div key={index} className="flex items-center text-gray-700">
                          <i className="ri-map-pin-line mr-2 text-lime-500"></i>
                          {area}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              
              <div>
                <div className="bg-gray-50 p-6 rounded-lg sticky top-6">
                  <div className="mb-6">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20residential%20home%20in%20George%20Garden%20Route%20South%20Africa%2C%20beautiful%20property%20with%20mountain%20views%2C%20painters%20in%20uniform%20with%20quality%20equipment%2C%20traditional%20architecture%2C%20organized%20work%20site%20with%20professional%20tools&width=400&height=300&seq=george-sidebar-image&orientation=landscape"
                      alt="Professional painters George Garden Route house painting services South Africa residential properties"
                      className="w-full h-48 object-cover object-top rounded-lg"
                    />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">Quick Contact</h3>
                  <div className="space-y-4">
                    <div className="flex items-center">
                      <i className="ri-mail-line mr-3 text-lime-500"></i>
                      <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                        {painter.email}
                      </a>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-global-line mr-3 text-lime-500"></i>
                      <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                        Visit Website
                      </a>
                    </div>
                  </div>
                  
                  <button 
                    onClick={() => navigate('/quote')}
                    className="w-full mt-6 bg-lime-400 text-black py-3 rounded-lg font-semibold hover:bg-lime-500 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Get Free Quote
                  </button>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'services' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Comprehensive Painting Services in George</h2>
              
              <div className="mb-12">
                <h3 className="text-2xl font-semibold text-gray-900 mb-6">Residential Painting Services</h3>
                <p className="text-gray-700 mb-8 leading-relaxed">
                  Our residential painting services in George are designed to enhance the beauty and value of your home while providing long-lasting protection against the Garden Route's diverse weather conditions. From single rooms to complete home transformations, we deliver exceptional results that reflect your personal style and complement the natural beauty of the Garden Route setting.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
                {painter.services.map((service, index) => (
                  <div key={index} className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow">
                    <div className="flex items-center mb-4">
                      <i className="ri-brush-line text-2xl text-lime-500 mr-3"></i>
                      <h3 className="text-lg font-semibold text-gray-900">{service}</h3>
                    </div>
                    <p className="text-gray-600">Professional {service.toLowerCase()} services with premium materials and expert Garden Route application techniques.</p>
                  </div>
                ))}
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                <div>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-4">Commercial and Industrial Painting</h3>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    Our commercial painting services in George cater to businesses, retail establishments, office buildings, and industrial facilities throughout the Garden Route. We understand the importance of maintaining professional appearances while minimizing business disruption. Our team works flexible schedules to accommodate business operations and delivers projects on time and within budget.
                  </p>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    For industrial clients, we offer specialized coating services that provide protection against harsh environmental conditions, chemical exposure, and heavy wear. Our industrial painting solutions include epoxy floor coatings, anti-corrosion treatments, and specialized protective finishes designed for manufacturing and processing facilities.
                  </p>
                </div>
                <div>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-4">Specialized Coating Services</h3>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    Beyond traditional painting, we offer specialized coating services including waterproofing, roof treatments, and protective finishes. Our waterproofing services are particularly important in the Garden Route climate, where moisture management is crucial for building longevity. We use advanced waterproofing systems that provide comprehensive protection while maintaining breathability.
                  </p>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    Our roof painting and coating services extend roof life while improving energy efficiency and weather resistance. We offer a range of roof coating options, from reflective coatings that reduce cooling costs to specialized treatments that prevent moss and algae growth in the Garden Route's humid conditions.
                  </p>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'gallery' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Recent Painting Projects in George</h2>
              <p className="text-gray-700 mb-12 leading-relaxed">
                Explore our portfolio of recent painting projects throughout George and the Garden Route. Each project demonstrates our commitment to quality workmanship and our expertise in handling the unique challenges of Garden Route painting applications.
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {painter.gallery.map((image, index) => (
                  <div key={index} className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                    <img 
                      src={image} 
                      alt={`${painter.name} project ${index + 1}`}
                      className="w-full h-64 object-cover object-top"
                    />
                    <div className="p-4">
                      <h3 className="font-semibold text-gray-900 mb-2">George Project {index + 1}</h3>
                      <p className="text-gray-600 text-sm">Professional Garden Route painting with premium materials and expert application techniques.</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'reviews' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Customer Reviews and Testimonials</h2>
              <p className="text-gray-700 mb-12 leading-relaxed">
                Read what our satisfied customers throughout George and the Garden Route have to say about our painting services. Our commitment to excellence and customer satisfaction is reflected in these genuine reviews from homeowners and business owners in the area.
              </p>
              
              <div className="space-y-6">
                {painter.testimonials.map((testimonial, index) => (
                  <div key={index} className="bg-white border border-gray-200 rounded-lg p-6">
                    <div className="flex items-center mb-4">
                      <div className="flex items-center">
                        {[...Array(5)].map((_, i) => (
                          <i key={i} className={`ri-star-fill ${i < testimonial.rating ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                        ))}
                      </div>
                      <span className="ml-3 font-semibold text-gray-900">{testimonial.name}</span>
                    </div>
                    <p className="text-gray-700 leading-relaxed">{testimonial.comment}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'contact' && (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Contact Painters George</h2>
                <p className="text-gray-700 mb-8 leading-relaxed">
                  Ready to transform your George property with professional painting services? Contact us today for a free consultation and quote. We're here to help you achieve beautiful, long-lasting results that enhance your Garden Route lifestyle.
                </p>
                
                <div className="space-y-6">
                  <div className="flex items-center">
                    <i className="ri-mail-line text-2xl text-lime-500 mr-4"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Email</h3>
                      <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                        {painter.email}
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <i className="ri-global-line text-2xl text-lime-500 mr-4"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Website</h3>
                      <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                        {painter.website}
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <i className="ri-map-pin-line text-2xl text-lime-500 mr-4 mt-1"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Service Area</h3>
                      <p className="text-gray-700">{painter.location} and surrounding Garden Route areas</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Get Your Free Quote Today</h3>
                <p className="text-gray-700 mb-6 leading-relaxed">
                  Request a free, no-obligation quote for your George painting project. Our experienced team will assess your property and provide detailed recommendations tailored to Garden Route conditions.
                </p>
                <button 
                  onClick={() => navigate('/quote')}
                  className="w-full bg-lime-400 text-black py-4 rounded-lg font-semibold hover:bg-lime-500 transition-colors text-lg whitespace-nowrap cursor-pointer"
                >
                  Request Free Quote
                </button>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
